module.exports = __webpack_public_path__ + "img/phone_tagMultiColor.e76ef77a.png";